import { ProtectedRoute } from "@/routes/utils/ProtectedRoute.tsx";
import { RedirectWithQuery } from "@/routes/utils/RedirectWithQuery.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { Route, RouteObject } from "react-router-dom";

const resolveRouteElement = (route: RouteConfig): React.ReactNode => {
  let element = route.element;

  if (route.redirect) {
    element = <RedirectWithQuery to={route.redirect} />;
  }

  if (
    route.planFeature ||
    route.anyOfPermissions ||
    route.allOfPermissions ||
    route.anyOfViewPermissions ||
    route.allOfEditFieldPermissions ||
    route.anyOfEditFieldPermissions
  ) {
    element = <ProtectedRoute config={route} />;
  }

  return element;
};

export const generateRoutes = (routes: RouteConfig[]): React.ReactNode => {
  return routes.map((route) => {
    return (
      <Route key={route.path} path={route.path || ""} element={resolveRouteElement(route)}>
        {route.children && generateRoutes(route.children)}
      </Route>
    );
  });
};

export const generateRouteObjects = (routes: RouteConfig[]): RouteObject[] => {
  return routes.map((route) => ({
    path: route.path || "",
    element: resolveRouteElement(route),
    children: route.children ? generateRouteObjects(route.children) : undefined,
  }));
};
